import { render, staticRenderFns } from "./finance-package-details.vue?vue&type=template&id=21c949cc&scoped=true&"
import script from "./finance-package-details.vue?vue&type=script&lang=js&"
export * from "./finance-package-details.vue?vue&type=script&lang=js&"
import style0 from "./finance-package-details.vue?vue&type=style&index=0&id=21c949cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c949cc",
  null
  
)

export default component.exports